export default {
    defaultIconUrl: "https://maps.gstatic.com/mapfiles/transparent.png",
    clickableIcons: false,
    streetViewControl: false,
    panControlOptions: false,
    mapTypeControl: false,
    gestureHandling: "greedy",
    mapTypeControlOptions: {
        position: 9
    },
    fullscreenControl: true,
    fullscreenControlOptions: {
        position: 3
    },
    zoomControl: true,
    zoomControlOptions: {
        position: 7
    },
    zoom: 15,
    minZoom: 2,
    maxZoom: 22,
    styles: [
        {
            featureType: "landscape",
            stylers: []
        },
        {
            featureType: "poi",
            elementType: "geometry.fill",
            stylers: [
                {
                    color: "#C5E3BF"
                }
            ]
        },
        {
            featureType: "road",
            elementType: "geometry",
            stylers: [
                {
                    lightness: 100
                },
                {
                    visibility: "simplified"
                }
            ]
        },
        {
            featureType: "road",
            elementType: "geometry.fill",
            stylers: [
                {
                    color: "#D1D1B8"
                }
            ]
        },
        {
            featureType: "road.highway",
            stylers: []
        },
        {
            featureType: "road.arterial",
            stylers: []
        },
        {
            featureType: "road.local",
            stylers: [
                {
                    visibility: "on"
                }
            ]
        },
        {
            featureType: "transit",
            stylers: [
                {
                    visibility: "on"
                }
            ]
        },
        {
            featureType: "administrative.province",
            stylers: [
                {
                    visibility: "on"
                }
            ]
        },
        {
            featureType: "administrative.locality",
            stylers: [
                {
                    visibility: "on"
                }
            ]
        },
        {
            featureType: "administrative.province",
            stylers: [
                {
                    visibility: "on"
                }
            ]
        },
        {
            featureType: "administrative.land_parcel",
            stylers: [
                {
                    visibility: "on"
                }
            ]
        },
        {
            featureType: "administrative.neighborhood",
            stylers: [
                {
                    visibility: "on"
                }
            ]
        },
        {
            featureType: "administrative.country",
            elementType: "geometry.stroke"
        },
        {
            featureType: "administrative",
            elementType: "labels",
            stylers: [
                {
                    visibility: "on"
                }
            ]
        },
        {
            featureType: "water",
            stylers: [
                {
                    visibility: "on"
                },
                {
                    color: "#C6E2FF"
                }
            ]
        }
    ]
};
